// Func = limiting Scope for this file
let lastScrollTop = 0;
let timeout;
let subtleParallaxEvents = [];

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const updateAssets = () => {
	const width = window.innerWidth;
	const breakpoint = 768;
	
	if(document.querySelectorAll('.js-responsive-asset').length > 0){
		const assets = document.querySelectorAll('.js-responsive-asset');
		assets.forEach(el => {
			const newSrc = width < breakpoint 
			? el.getAttribute('data-mobile') 
			: el.getAttribute('data-desktop');

			if (newSrc !== '' && newSrc !== el.src) {
				el.src = newSrc;
			}
		});
	}
	if(document.querySelectorAll('.js-gallery-trigger').length > 0){
		if(width < breakpoint){
			document.querySelectorAll('.js-gallery-trigger').forEach(expand => {
				expand.addEventListener('click', (e) => {
					e.preventDefault();
				})
			});
		}
	}

	
};

function subtleParallax(el,index){

	let parallaxFunction = () => {
		let depth = el.dataset.depth;
		let move = window.pageYOffset * depth;
		el.style.transform = `translateY(${move}px)`;
		
	}

	subtleParallaxEvents[index] = parallaxFunction;
	window.addEventListener('scroll', subtleParallaxEvents[index]);
} 

function resizeWindow(){
	clearTimeout(timeout);
	timeout = setTimeout(updateAssets, 200);
}

//
(function(){

	let mainGallery = new LBX('.js-full-lbx', {});
	mainGallery.fullScreen = true;
	
	document.addEventListener('DOMContentLoaded', function() {
		if(document.querySelector('.hero') && (document.documentElement.clientWidth > 768)) {
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}else if(document.querySelector('.hero')){
			window.addEventListener('scroll', function(){
				scrollW();
			});				
		}else{
			document.querySelector('header').classList.add('down');
			if(document.querySelector('.js-logo')){
				document.querySelector('.js-logo').classList.add('changed');
				document.querySelector('.js-logo').setAttribute('src', document.querySelector('.js-logo').getAttribute('data-scroll'))
			}
		}

		updateAssets();

	});

	
	window.addEventListener('resize', () => {
		resizeWindow();
		
	});

	// FORM focus animation
	if(document.querySelectorAll('.form-module__field:not(.gdpr)').length > 0){
		document.querySelectorAll('.form-module__field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}
	//Default Signup
	if(document.querySelectorAll('.field:not(.gdpr)').length > 0){
		document.querySelectorAll('.field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//Links that open the menus:
	if(document.querySelectorAll('.js-go-to-link').length > 0){
		document.querySelectorAll('.js-go-to-link').forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				let linkTarget = link.getAttribute('href');
				
				if(document.querySelector(`${linkTarget}`)){
					document.querySelector(`${linkTarget}`).scrollIntoView({ behavior: 'smooth' });
				}
			})
		})
	}

	//subtle parallax animation
	if(document.querySelectorAll('.js-media-observer').length > 0){


		function subtleParallax(el,index){
			let elementAsset = el.querySelector('img') || el.querySelector('video');
			if (!elementAsset) return;

    		let ticking = false;
			let parallaxFunction = () => {
				if (!ticking) {
					window.requestAnimationFrame(() => {
						// 1. Get element position relative to viewport
						const rect = el.getBoundingClientRect();
						const viewportHeight = window.innerHeight;

					
						let progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
						progress = Math.max(0, Math.min(1, progress));

						const maxMove = 18; 
						const move = (progress * maxMove);

						elementAsset.style.transform = `translateY(${move}%)`;
						ticking = false;
					});
					ticking = true;
				}
				
			}

			subtleParallaxEvents[index] = parallaxFunction;
			window.addEventListener('scroll', parallaxFunction);
		} 


		let observerOptions = {
			root: null,
			rootMargin: '0px',
			threshold: 0.4
		}

		const assetObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				let realIndex = Array.from(document.querySelectorAll('.js-media-observer')).indexOf(entry.target);
				
				if (entry.isIntersecting) {
					entry.target.classList.add('in-viewport');
					subtleParallax(entry.target,realIndex);

				} else {
					entry.target.classList.remove('in-viewport');
					window.removeEventListener('scroll', subtleParallaxEvents[realIndex]);
				}
				});
			}, {
			observerOptions
		});
		document.querySelectorAll('.js-media-observer').forEach(el => assetObserver.observe(el));
	}

	//burger menu 
	if(document.querySelector('.js-menu')){
		document.querySelector('.js-menu').addEventListener('click', () => {
			document.querySelector('.js-menu').classList.toggle('open');
			document.querySelector('.js-header-nav').classList.toggle('open');
			document.querySelector('.js-menu').classList.contains('open') ? document.querySelector('.js-menu').querySelector('.text').innerHTML = 'close' : document.querySelector('.js-menu').querySelector('.text').innerHTML = 'menu';
		});
	}

	//ADA menus tabbing
	tabsAndADA();

})();

function tabsAndADA(){

	if(document.querySelectorAll('[role="tablist"]').length > 0 ){
		document.querySelectorAll('[role="tablist"]').forEach(tablist => {
			const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
			const panels = tabs.map(t => document.getElementById(t.getAttribute('aria-controls')));

			function activate(index, setFocus = true) {
				tabs.forEach((tab, i) => {
					const selected = i === index;
					tab.setAttribute('aria-selected', selected);
					tab.setAttribute('tabindex', selected ? '0' : '-1');
					panels[i].hidden = !selected;
				});
				if (setFocus) tabs[index].focus();
			}

			tablist.addEventListener('keydown', (e) => {
				const current = tabs.indexOf(document.activeElement);
				if (current < 0) return;
					let next = current;
					switch (e.key) {
					case 'ArrowRight': next = (current + 1) % tabs.length; break;
					case 'ArrowLeft':  next = (current - 1 + tabs.length) % tabs.length; break;
					case 'Home':       next = 0; break;
					case 'End':        next = tabs.length - 1; break;
					default: return;
				}
				e.preventDefault();
				activate(next);
			});

			tabs.forEach((tab, i) => tab.addEventListener('click', () => {
				activate(i);
				tab.focus();
				tabs.forEach( t => t.classList.remove('active'));
				tab.classList.add('active');
			}));
		});
	}
	if(document.querySelectorAll('.faq-trigger').length > 0){
		const triggers = Array.from(document.querySelectorAll('.faq-trigger'));
		triggers.forEach((trigger) => {
			trigger.addEventListener('click', () => {
				const expanded = trigger.getAttribute('aria-expanded') === 'true';
				const panel = document.getElementById(trigger.getAttribute('aria-controls'));
				trigger.setAttribute('aria-expanded', String(!expanded));
				panel.hidden = expanded;
				trigger.parentElement.classList.toggle('active');
			});

			trigger.addEventListener('keydown', (e) => {
				const i = triggers.indexOf(trigger);
				let next = i;
				switch (e.key) {
					case 'ArrowDown': next = (i + 1) % triggers.length; break;
					case 'ArrowUp':   next = (i - 1 + triggers.length) % triggers.length; break;
					case 'Home':      next = 0; break;
					case 'End':       next = triggers.length - 1; break;
					default: return;
				}
				e.preventDefault();
				triggers[next].focus();
			});
		});
	}
}

function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down'))  {
			document.getElementById('header').classList.add('down');
			if(document.querySelector('.js-logo')){
				
				setTimeout(() => {
					document.querySelector('.js-logo').classList.add('changed');
					document.querySelector('.js-logo').setAttribute('src', document.querySelector('.js-logo').getAttribute('data-scroll'))
				}, 500);
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('down');
			if(document.querySelector('.js-logo')){
				setTimeout(() => {
					document.querySelector('.js-logo').classList.remove('changed');
					document.querySelector('.js-logo').setAttribute('src', document.querySelector('.js-logo').getAttribute('data-original'))
				}, 600);
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}